import { render, staticRenderFns } from "./ContentSizeProperty.vue?vue&type=template&id=c463dd12&"
import script from "./ContentSizeProperty.vue?vue&type=script&lang=js&"
export * from "./ContentSizeProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports